import type { Block } from '@/blocks/domain/types';
import { BLOCK_KIND_LABELS, OTHER_BLOCK_KIND_LABEL } from '@/blocks/domain/types';

/**
 * The label a block's kind is shown under (library card kicker, editor kind pill). A supported kind
 * uses its board copy; an UNSUPPORTED kind shows the raw stored value (never "Letterhead", which is
 * what coercing it to `header` used to print), or "Other" when the API sent none.
 */
export function blockKindDisplayLabel(block: Pick<Block, 'kind' | 'rawKind' | 'isSupportedKind'>): string {
  if (block.isSupportedKind === false) return block.rawKind?.trim() || OTHER_BLOCK_KIND_LABEL;
  return BLOCK_KIND_LABELS[block.kind] ?? block.kind;
}
